import { ErrorModel } from '@era/app';
import { AppLockState, ModelNameFlags } from '@era/settings-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { Category } from '../router/category';
import { CategoryType } from '../shared/types';
import { AppLock, AppLocks, AppleBundleIdentifier } from './category-app-lock.state';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================

export const CategoryAppLockResolverActions = createActionGroup({
  source: 'Category app lock resolver',
  events: {
    'Category app lock requested': props<{ category: Category; modelNames: ModelNameFlags[] }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const AppLockApiActions = createActionGroup({
  source: 'App Lock API',
  events: {
    'App lock loaded': props<{ category: Category; appLocks: AppLock[] }>(),
    'App lock loaded error': props<{ error: ErrorModel }>(),
    'App lock set': props<{ category: Category; appLocks: AppLocks }>(),
    'App lock set error': props<{ error: ErrorModel }>(),
    'App lock removed': props<{ category: Category; appLocks: AppLocks }>(),
    'App lock removed error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS
// ============================================================================

export const CategoryAppLockViewActions = createActionGroup({
  source: 'Category app lock view',
  events: {
    'App lock selected': props<{
      categoryType: CategoryType;
      bundleIdentifier: AppleBundleIdentifier;
      modelNames: ModelNameFlags[];
      deviceState?: AppLockState; // optional for room, bar, frontdesk, housekeeping, kiosk, staff
    }>(),
    'App lock removed': props<{
      categoryType: CategoryType;
      bundleIdentifier: AppleBundleIdentifier;
      modelNames: ModelNameFlags[];
      deviceState?: AppLockState; // optional for room, bar, frontdesk, housekeeping, kiosk, staff
    }>(),
  },
});
